import { FC, Fragment } from 'react';

import { DyePenetrantInspectionProps, Project } from '../../../../utils/models';
import { formatTime } from '../../../../utils/utilities';
import { getLPTColumns } from '../../../../utils/data';

import GridItem from '../general/gridItem';
import PDFTablePage from '../../../themed/pdf/pdfTablePage';

import css from '../pdf.module.scss';

interface DPIProps extends DyePenetrantInspectionProps {
	projectDetails: Project;
}

const DyePenetrantInspection: FC<DPIProps> = (props) => {
	return (
		<Fragment>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem
							title="Client:"
							value={props.projectDetails.organisation.organisationName}
						/>
						<GridItem title="Location:" value={props.projectDetails.location} />
						<GridItem
							title="Facility:"
							value={props.projectDetails.facility.facilityName}
						/>
						<GridItem
							title="Tag No/Identification:"
							value={props.projectDetails.equipmentTag}
						/>
					</div>

					<div className="col">
						<GridItem
							title="Date:"
							value={formatTime(props.projectDetails.createdAt)}
						/>
						<GridItem
							title="Report No:"
							value={props.projectDetails.documentNumber}
						/>
						<GridItem title="Material:" value={props.material} />
						<GridItem title="Thickness (mm):" value={props.thickness} />
					</div>
				</div>
			</div>

			<div className={css['title-grid'] + ' p-2'}></div>

			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem
							title="Surface condition:"
							value={props.surfaceCondition}
						/>
						<GridItem title="Developer:" value={props.developer} />
						<GridItem title="Method:" value={props.method} />
						<GridItem title="Dwell time:" value={props.dwellTime} />
						<GridItem title="Penetrant:" value={props.penetrant} />
					</div>

					<div className="col">
						<GridItem title="Developing time:" value={props.developingTime} />
						<GridItem
							title="Penetrant Remover:"
							value={props.penetrantRemover}
						/>
						<GridItem title="Ref. Std.:" value={props.refStd} />
						<GridItem title="Acceptance Std.:" value={props.acceptanceStd} />
						<GridItem title="Procedure No.:" value={props.procedureNo} />
					</div>
				</div>
			</div>

			<div>
				<div className={css['title-grid'] + ' text-uppercase font-weight-bold'}>
					Summary
				</div>
				<div className={css['title-grid-value']}>{props.summary}</div>
			</div>

			<PDFTablePage data={props.data} columns={getLPTColumns()} />
		</Fragment>
	);
};

export default DyePenetrantInspection;
